import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admissions from "@/pages/Admissions";
import ApplicantTypePage from "@/pages/ApplicantTypePage";
import Requirements from "@/pages/Requirements";
import Apply from "@/pages/Apply";
import ApplicationStatus from "@/pages/ApplicationStatus";
import Academics from "@/pages/Academics";
import Department from "@/pages/Department";
import Program from "@/pages/Program";
import Tuition from "@/pages/Tuition";
import CampusLife from "@/pages/CampusLife";
import Library from "@/pages/Library";
import Portal from "@/pages/Portal";
import MobileApp from "@/pages/MobileApp";
import About from "@/pages/About";
import Leadership from "@/pages/Leadership";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Contact from "@/pages/Contact";
import CampusVisit from "@/pages/CampusVisit";
import Faq from "@/pages/Faq";
import ForeignInquiry from "@/pages/ForeignInquiry";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import ApplicantDashboard from "@/pages/ApplicantDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<PublicLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/admissions" element={<Admissions />} />
                    <Route path="/admissions/apply" element={<Apply />} />
                    <Route path="/admissions/status" element={<ApplicationStatus />} />
                    <Route path="/admissions/requirements" element={<Requirements />} />
                    <Route path="/admissions/foreign-inquiry" element={<ForeignInquiry />} />
                    <Route path="/admissions/:code" element={<ApplicantTypePage />} />
                    <Route path="/academics" element={<Academics />} />
                    <Route path="/academics/:slug" element={<Department />} />
                    <Route path="/programs/:slug" element={<Program />} />
                    <Route path="/tuition-scholarships" element={<Tuition />} />
                    <Route path="/campus-life" element={<CampusLife />} />
                    <Route path="/library" element={<Library />} />
                    <Route path="/portal" element={<Portal />} />
                    <Route path="/mobile-app" element={<MobileApp />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/about/leadership" element={<Leadership />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/news/:slug" element={<NewsDetail />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/campus-visit" element={<CampusVisit />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/legal/:doc" element={<Legal />} />
                    <Route path="/applicant/:reference" element={<ApplicantDashboard />} />
                    <Route path="/404" element={<NotFound />} />
                    <Route path="*" element={<Navigate to="/404" replace />} />
                </Route>
                <Route path="/admin" element={<><AdminDashboard /><Toaster richColors position="top-center" /></>} />
            </Routes>
        </BrowserRouter>
    );
}
